export const LEG_STATUSES = ['CREATED', 'ASSIGNED', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'] as const
export type LegStatus = typeof LEG_STATUSES[number]

export const DISPATCH_STATUSES = [
  'ASSIGNED',
  'EN_ROUTE_PICKUP',
  'AT_PICKUP',
  'LOADING',
  'IN_TRANSIT',
  'AT_DELIVERY',
  'UNLOADING',
  'COMPLETED',
  'CANCELLED',
] as const
export type DispatchStatus = typeof DISPATCH_STATUSES[number]

export const ACTIVE_DISPATCH_STATUSES: DispatchStatus[] = [
  'ASSIGNED',
  'EN_ROUTE_PICKUP',
  'AT_PICKUP',
  'LOADING',
  'IN_TRANSIT',
  'AT_DELIVERY',
  'UNLOADING',
]

export const DISPATCH_TRANSITIONS: Record<DispatchStatus, DispatchStatus[]> = {
  ASSIGNED: ['EN_ROUTE_PICKUP', 'CANCELLED'],
  EN_ROUTE_PICKUP: ['AT_PICKUP', 'CANCELLED'],
  AT_PICKUP: ['LOADING', 'CANCELLED'],
  LOADING: ['IN_TRANSIT', 'CANCELLED'],
  IN_TRANSIT: ['AT_DELIVERY', 'CANCELLED'],
  AT_DELIVERY: ['UNLOADING'],
  UNLOADING: ['COMPLETED'],
  COMPLETED: [],
  CANCELLED: [],
}

export function isValidDispatchTransition(from: DispatchStatus, to: DispatchStatus): boolean {
  return DISPATCH_TRANSITIONS[from].includes(to)
}

export function isTerminalDispatchStatus(status: DispatchStatus): boolean {
  return status === 'COMPLETED' || status === 'CANCELLED'
}

export function isActiveLegStatus(status: LegStatus): boolean {
  return status !== 'COMPLETED' && status !== 'CANCELLED'
}

export type SpecialRequirements = {
  needsCrane?: boolean
  needsForklift?: boolean
  [key: string]: unknown
}

export function getDispatchStatusColor(status: DispatchStatus): string {
  switch (status) {
    case 'ASSIGNED': return 'blue'
    case 'EN_ROUTE_PICKUP': return 'yellow'
    case 'AT_PICKUP': return 'orange'
    case 'LOADING': return 'orange'
    case 'IN_TRANSIT': return 'purple'
    case 'AT_DELIVERY': return 'teal'
    case 'UNLOADING': return 'teal'
    case 'COMPLETED': return 'green'
    case 'CANCELLED': return 'red'
    default: return 'default'
  }
}

export function getLegStatusColor(status: LegStatus): string {
  switch (status) {
    case 'CREATED': return 'default'
    case 'ASSIGNED': return 'blue'
    case 'IN_PROGRESS': return 'purple'
    case 'COMPLETED': return 'green'
    case 'CANCELLED': return 'red'
    default: return 'default'
  }
}
